<script context="module">
    import {apiRequest} from "./Request.svelte";

    export const reviveSubscription = async () => await apiRequest('GET', '/instashpion/api/revive-spy-subscribe', null, {});
    export const cancelSubscription = async () => await apiRequest('POST', '/instashpion/api/unsubscribe', (new URLSearchParams({})).toString());
    export const addAdditionalTrial = async () => await apiRequest('POST', '/instashpion/payments-api/add-additional-trial', (new URLSearchParams({})).toString());
    export const removeTemporaryAnalyze = async (id) => await apiRequest('POST', '/instashpion/api/temp-analyze-delete', (new URLSearchParams({id})).toString());
    export const removeAnalyze = async (id) => await apiRequest('POST', '/instashpion/api/analyze-delete', (new URLSearchParams({id})).toString());
    export const findInstagramUser = async(query) => await apiRequest('POST', '/instashpion/api/search', (new URLSearchParams({query: query})).toString());
    export const getUserInfo = async(username) => await apiRequest('POST', '/instashpion/api/get-info', (new URLSearchParams({
        username: username,
    })).toString());

    export const createTemporaryAnalyze = async(victimInstagramId, victimUsername, victimName, victimPhoto, victimMedias = 0, victimFollows = 0, victimFollowers = 0, isSelf = 0) => await apiRequest('POST', '/instashpion/api/create-temp-analyze', (new URLSearchParams({
        victim_instagram_id: victimInstagramId,
        victim_username: victimUsername,
        victim_name: victimName,
        victim_medias: victimMedias,
        victim_follows: victimFollows,
        victim_followers: victimFollowers,
        victim_photo: victimPhoto,
        isSelf: isSelf,
    })).toString());

    export const applyCancellationDiscount = async () => await apiRequest('POST', '/instashpion/payments-api/apply-discount', (new URLSearchParams({
        'tariff[analyzes]': 3,
        'tariff[period]': 7,
    })).toString());

    export const applyPromo = async (code) => await apiRequest('POST', '/site/add-promo', (new URLSearchParams({
        code: code,
    })).toString());

    export const changeAutogeneratedEmail = async (email, sourceKey = '', sourceVal = '') => await apiRequest('POST', `/instashpion/api/change-autogenerated-email?source_key=${sourceKey}&source_val=${sourceVal}`, (new URLSearchParams({
        email: email,
    })).toString());

    export const changeUserInfo = async (email, oldPassword, newPassword) => await apiRequest('POST', `/instashpion/api/change-password-spy`, (new URLSearchParams({
        'UserPasswordChangeForm[email]': email,
        'UserPasswordChangeForm[old_password]': oldPassword,
        'UserPasswordChangeForm[new_password]': newPassword,
        'UserPasswordChangeForm[is_instashpion]': 1,
    })).toString());

    export const changeAutoRegInfo = async (email, password, passwordRepeat) => await apiRequest('POST', `/instashpion/api/change-reg-auto`, (new URLSearchParams({
        email: email,
        password: password,
        password_repeat: passwordRepeat,
    })).toString());

    export const cancelAutoRegInfo = async () => await apiRequest('POST', `/instashpion/api/cancel-reg-auto`).toString();
    export const keepAutoRegPassword = async () => await apiRequest('POST', `/instashpion/api/keep-reg-auto-password`).toString();

    export const updateNotificationSettings = async (emailReadyNotify, emailReportSend, telegramReportSend, reportsFrequency) => await apiRequest(
        'POST',
        '/instashpion/api/new-notification-settings',
        (new URLSearchParams({
            email: emailReadyNotify,
            emailUpdate: emailReportSend,
            telegram: telegramReportSend,
            frequency: reportsFrequency,
        })).toString()
    );

    export const loadMoreComments = async(id, limit = 10, offset = 10, date = null) => await apiRequest('POST', '/instashpion/api/comment-result', (new URLSearchParams({
        id: id,
        limit: limit,
        offset: offset,
        date: date
    })).toString());

    export const loadMoreFollows = async(id, limit = 10, offset = 10, date = null) => await apiRequest('POST', '/instashpion/api/follow-result', (new URLSearchParams({
        id: id,
        limit: limit,
        offset: offset,
        date: date
    })).toString());

    export const loadMoreFollowers = async(id, limit = 10, offset = 10, date = null) => await apiRequest('POST', '/instashpion/api/follower-result', (new URLSearchParams({
        id: id,
        limit: limit,
        offset: offset,
        date: date
    })).toString());

    export const loadMoreStories = async(id, limit = 12, offset = 12, date = null) => await apiRequest('POST', '/instashpion/api/stories-result', (new URLSearchParams({
        id: id,
        limit: limit,
        offset: offset,
        date: date
    })).toString());

    export const loadMorePosts = async(id, limit = 12, offset = 12, date = null) => await apiRequest('POST', '/instashpion/api/posts-result', (new URLSearchParams({
        id: id,
        limit: limit,
        offset: offset,
        date: date
    })).toString());

    export const loadLikes = async(id, limit = 12, offset = 12, sort = 1, direction = 3, showType = 1, date = null) => await apiRequest('POST', '/instashpion/api/likes-result', (new URLSearchParams({
        id: id,
        limit: limit,
        offset: offset,
        sort: sort,
        direction: direction,
        showtype: showType,
        date: date
    })).toString());

    export const updateAnalyzeResult = async(id, date = null) => await apiRequest('GET', `/instashpion/api/apply?id=${id}&date=${date}`);

    export const forceFeedUpdate = async(id) => await apiRequest('POST', `/instashpion/api/force-feed-update?id=${id}`, (new URLSearchParams({})).toString());

    export const restartAnalyze = async(id) => await apiRequest('POST', `/instashpion/api/restart-analyze`, (new URLSearchParams({
        analyze_id: id,
    })).toString());

    export const createAnalyze = async(username, autostart = 1, analyze_type = 0) => await apiRequest('POST', `/instashpion/api/create-analyze`, (new URLSearchParams({
        username: username,
        autostart: autostart,
        analyze_type: analyze_type,
    })).toString());

    export const getAnalyzeProgress = async(id, date = null) => await apiRequest('GET', `/instashpion/api/progress?id=${id}&date=${date}`, (new URLSearchParams({})).toString());

    export const setPrivateAnalyzeHandler = async (analyzeId, accountId) => await apiRequest('POST', '/instashpion/api/set-handle-account', (new URLSearchParams({
        analyze_id: analyzeId,
        account_id: accountId,
    })).toString());

    export const updateHandler = async (oldHandlerId, newHandlerId) => await apiRequest('POST', '/instashpion/api/update-handler', (new URLSearchParams({
        old_handler_id: oldHandlerId,
        new_handler_id: newHandlerId,
    })).toString());

    export const unsetPrivateAnalyzeHandler = async (accountId) => await apiRequest('POST', '/instashpion/api/unset-handle-account', (new URLSearchParams({
        account_id: accountId,
    })).toString());
    export const addAccount = async(login, password) => await apiRequest('POST', '/account/add?service=4', (new URLSearchParams({
        'AccountCreateForm[login]': login,
        'AccountCreateForm[username]': login,
        'AccountCreateForm[password]': password,
    })).toString(), {
        'x-requested-with': 'XMLHttpRequest',
    });

    export const changeHandlerPassword = async(accountId, password) => await apiRequest('POST', '/instashpion/api/change-password', (new URLSearchParams({
        'account_id': accountId,
        'password': password,
    })).toString());

    export const refreshHandler = async(accountId) => await apiRequest('POST', '/instashpion/api/refresh-handler', (new URLSearchParams({
        'account_id': accountId
    })).toString());

    export const checkInvoiceStatus = async(id) => await apiRequest('GET', `/instashpion/payments-api/check-invoice-status?id=${id}`, (new URLSearchParams({})).toString());

    export const buyTrial = async(source = 'dashboard', agent = 'yandex_kassa') => await apiRequest('POST', '/instashpion/payments-api/buy-trial', (new URLSearchParams({
        'data[source]': source,
        'data[agent]': agent,
        'data[enable_self_analyze]': 0,
    })).toString());

    export const buyPremium = async(source = 'dashboard', agent = 'yandex_kassa') => await apiRequest('POST', '/instashpion/payments-api/buy-premium', (new URLSearchParams({
        'data[source]': source,
        'data[agent]': agent,
        'data[use_cash_back]': 0,
    })).toString());

    export const resetPassword = async(email, language, service = 'spy') => await apiRequest('POST', 'https://auth.zengram.ru/api/users/reset-password', (new URLSearchParams({
        email: email,
        language: language,
        service: service,
    })).toString());

    export const login = async(login, password) => await apiRequest('POST', '/users-api/login', (new URLSearchParams({
        email: login,
        password: password,
    })).toString(),
    {
        'Content-Type': 'application/x-www-form-urlencoded',
    })

    export const sendVerificationCode = async (accountId, checkpointId, code) => await apiRequest('POST', '/instashpion/api/verification-code', (new URLSearchParams({
            account_id: accountId,
            checkpoint_id: checkpointId,
            code
        })).toString(),
        {
            'Content-Type': 'application/x-www-form-urlencoded',
        });

</script>